export default `
<div class="styles__CategoryList">
  <div class="column ghost_featured"></div>
  <div class="column">
    <div class="group"><a href="/c/20001/men?tab=c&amp;cm_sp=topnav_c_m">
        <h2 class="title">Men</h2>
      </a>
      <ul>
        <li><a href="/c/20001-20015/jackets-vests?tab=c&amp;cm_sp=topnav_c_m_jackets-vests">
            <div class="item">
              <div class="item-label">Jackets &amp; Vests</div>
            </div>
          </a></li>
        <li><a href="/c/20001-20021/bottoms?tab=c&amp;cm_sp=topnav_c_m_bottoms">
            <div class="item">
              <div class="item-label">Bottoms</div>
            </div>
          </a></li>
        <li><a href="/c/20001-20052/tops?tab=c&amp;cm_sp=topnav_c_m_tops">
            <div class="item">
              <div class="item-label">Tops</div>
            </div>
          </a></li>
        <li><a href="/c/20001-140004/fleece?tab=c&amp;cm_sp=topnav_c_m_fleece">
            <div class="item">
              <div class="item-label">Fleece</div>
            </div>
          </a></li>
        <li><a href="/c/20001-20030/footwear?tab=c&amp;cm_sp=topnav_c_m_footwear">
            <div class="item">
              <div class="item-label">Footwear</div>
            </div>
          </a></li>
        <li><a href="/c/20001-20002/accessories?tab=c&amp;cm_sp=topnav_c_m_accessories">
            <div class="item">
              <div class="item-label">Accessories</div>
            </div>
          </a></li>
      </ul>
    </div>
    <div class="group"><a href="/c/20094/women?tab=c&amp;cm_sp=topnav_c_w_w">
        <h2 class="title">Women</h2>
      </a>
      <ul>
        <li><a href="/c/20094-20117/jackets-vests?tab=c&amp;cm_sp=topnav_c_w_jackets-vests">
            <div class="item">
              <div class="item-label">Jackets &amp; Vests</div>
            </div>
          </a></li>
        <li><a href="/c/20094-20123/bottoms?tab=c&amp;cm_sp=topnav_c_w_bottoms">
            <div class="item">
              <div class="item-label">Bottoms</div>
            </div>
          </a></li>
        <li><a href="/c/20094-20150/tops?tab=c&amp;cm_sp=topnav_c_w_tops">
            <div class="item">
              <div class="item-label">Tops</div>
            </div>
          </a></li>
        <li><a href="/c/20094-140003/fleece?tab=c&amp;cm_sp=topnav_c_w_fleece">
            <div class="item">
              <div class="item-label">Fleece</div>
            </div>
          </a></li>
        <li><a href="/c/20094-20130/footwear?tab=c&amp;cm_sp=topnav_c_w_footwear">
            <div class="item">
              <div class="item-label">Footwear</div>
            </div>
          </a></li>
        <li><a href="/c/20094-20095/accessories?tab=c&amp;cm_sp=topnav_c_w_accessories">
            <div class="item">
              <div class="item-label">Accessories</div>
            </div>
          </a></li>
      </ul>
    </div>
    <div class="group"><a href="/c/20082/kids?tab=c&amp;cm_sp=topnav_c_kids">
        <h2 class="title">Kids</h2>
      </a>
      <ul>
        <li><a href="/c/20082-20083/boys?tab=c&amp;cm_sp=topnav_c_kids_boys">
            <div class="item">
              <div class="item-label">Boys</div>
            </div>
          </a></li>
        <li><a href="/c/20082-20088/girls?tab=c&amp;cm_sp=topnav_c_kids_girls">
            <div class="item">
              <div class="item-label">Girls</div>
            </div>
          </a></li>
      </ul>
    </div>
  </div>
</div>
`
